import { COLORS } from "../../shared/constants";
import { IconEdit } from "../../shared/icons";
import { useState } from "react";
import * as api from "../../api";

export default // ─── Diagnoses Tab ────────────────────────────────
function DiagnosesTab({ diagnoses, onRefresh }) {
  const [newCode, setNewCode] = useState("");
  const [newDesc, setNewDesc] = useState("");
  const [editing, setEditing] = useState(null);
  const [editCode, setEditCode] = useState("");
  const [editDesc, setEditDesc] = useState("");

  const reload = async () => {
    try {
      const res = await api.getSettings("diagnoses");
      onRefresh(res.items || []);
    } catch (e) { console.error("Reload diagnoses:", e); }
  };

  const handleAdd = async () => {
    if (!newCode.trim()) return;
    try {
      await api.createSetting("diagnoses", { code: newCode.trim(), description: newDesc.trim() });
      await reload();
      setNewCode(""); setNewDesc("");
    } catch (e) { console.error("Add diagnosis:", e); }
  };
  const handleToggle = async (id) => {
    const d = diagnoses.find((x) => x.id === id);
    if (!d) return;
    try {
      await api.updateSetting("diagnoses", id, { is_active: !d.is_active });
      await reload();
    } catch (e) { console.error("Toggle diagnosis:", e); }
  };
  const handleRename = async (id) => {
    try {
      await api.updateSetting("diagnoses", id, { code: editCode.trim(), description: editDesc.trim() });
      await reload();
    } catch (e) { console.error("Update diagnosis:", e); }
    setEditing(null);
  };

  const active = diagnoses.filter((d) => d.is_active);
  const inactive = diagnoses.filter((d) => !d.is_active);

  return (
    <div>
      <h3 style={{ fontSize: "16px", fontWeight: "600", color: COLORS.text, marginBottom: "16px" }}>Diagnoses / ICD-10</h3>
      <div style={{ display: "flex", gap: "8px", marginBottom: "16px" }}>
        <input style={{ width: "120px", height: "40px", padding: "0 12px", borderRadius: "8px", border: `1px solid ${COLORS.border}`, background: COLORS.inputBg, fontSize: "14px", outline: "none" }}
          value={newCode} onChange={(e) => setNewCode(e.target.value)} placeholder="ICD-10 code" />
        <input style={{ flex: 1, height: "40px", padding: "0 12px", borderRadius: "8px", border: `1px solid ${COLORS.border}`, background: COLORS.inputBg, fontSize: "14px", outline: "none" }}
          value={newDesc} onChange={(e) => setNewDesc(e.target.value)} placeholder="Description"
          onKeyDown={(e) => e.key === "Enter" && handleAdd()} />
        <button onClick={handleAdd} style={{ height: "40px", padding: "0 16px", borderRadius: "8px", border: "none", background: COLORS.accent, color: "#FFF", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}>Add</button>
      </div>
      {active.map((d) => (
        <div key={d.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 12px", borderBottom: `1px solid ${COLORS.borderLight}` }}>
          {editing === d.id ? (
            <div style={{ display: "flex", gap: "6px", flex: 1 }}>
              <input style={{ width: "100px", height: "32px", padding: "0 10px", borderRadius: "6px", border: `1px solid ${COLORS.border}`, fontSize: "13px" }} value={editCode} onChange={(e) => setEditCode(e.target.value)} />
              <input style={{ flex: 1, height: "32px", padding: "0 10px", borderRadius: "6px", border: `1px solid ${COLORS.border}`, fontSize: "13px" }} value={editDesc} onChange={(e) => setEditDesc(e.target.value)} />
              <button onClick={() => handleRename(d.id)} style={{ height: "32px", padding: "0 10px", borderRadius: "6px", border: "none", background: COLORS.primary, color: "#FFF", fontSize: "11px", fontWeight: "600", cursor: "pointer" }}>Save</button>
              <button onClick={() => setEditing(null)} style={{ height: "32px", padding: "0 10px", borderRadius: "6px", border: `1px solid ${COLORS.border}`, background: "transparent", fontSize: "11px", cursor: "pointer", color: COLORS.textSecondary }}>Cancel</button>
            </div>
          ) : (
            <>
              <span style={{ fontSize: "14px", color: COLORS.text }}>
                <strong style={{ color: COLORS.primary }}>{d.code}</strong>
                {d.description && <span style={{ color: COLORS.textSecondary }}> — {d.description}</span>}
              </span>
              <div style={{ display: "flex", gap: "4px" }}>
                <button onClick={() => { setEditing(d.id); setEditCode(d.code); setEditDesc(d.description); }} style={{ height: "28px", padding: "0 8px", borderRadius: "6px", border: `1px solid ${COLORS.border}`, background: COLORS.surface, color: COLORS.primary, fontSize: "11px", fontWeight: "600", cursor: "pointer", display: "flex", alignItems: "center", gap: "3px" }}><IconEdit /></button>
                <button onClick={() => handleToggle(d.id)} style={{ height: "28px", padding: "0 8px", borderRadius: "6px", border: `1px solid ${COLORS.dangerBorder}`, background: COLORS.dangerLight, color: COLORS.danger, fontSize: "11px", fontWeight: "600", cursor: "pointer" }}>Deactivate</button>
              </div>
            </>
          )}
        </div>
      ))}
      {inactive.length > 0 && (
        <div style={{ marginTop: "16px" }}>
          <div style={{ fontSize: "12px", fontWeight: "600", color: COLORS.textSecondary, marginBottom: "8px" }}>Deactivated</div>
          {inactive.map((d) => (
            <div key={d.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", background: COLORS.inputBg, borderRadius: "6px", marginBottom: "4px" }}>
              <span style={{ fontSize: "13px", color: COLORS.textSecondary, textDecoration: "line-through" }}>{d.code} — {d.description}</span>
              <button onClick={() => handleToggle(d.id)} style={{ height: "26px", padding: "0 8px", borderRadius: "6px", border: `1px solid ${COLORS.border}`, background: COLORS.surface, color: COLORS.accent, fontSize: "11px", fontWeight: "600", cursor: "pointer" }}>Reactivate</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── Placeholder Tab ──────────────────────────────

